// extracted by mini-css-extract-plugin
export var phone = "_2i-0";